import { PropertyResponseDto } from "@/common/api/datasources/Api";
import { Routes, Route } from "react-router-dom";
import { LeaseDetailsPage } from "@/modules/Leases/pages/LeaseDetailsPage";
import { LeasesList } from "./LeasesList";
import LeaseCreatePage from "@/modules/Leases/pages/LeaseCreatePage";

export interface LeasesTabProps {
    property: PropertyResponseDto;
}

export const LeasesTab = ({ property }: LeasesTabProps) => (
    <Routes>
        <Route index element={<LeasesList property={property} />} />
        <Route path="create" element={<LeaseCreatePage />} />
        <Route path=":leaseUUID" element={<LeaseDetailsPage />} />
    </Routes>
);